import { FILTER_PARAM_NAMES } from 'client-portal/utils/clinicianSearch/facets/manifest';
import { cached, tracked } from '@glimmer/tracking';
import {
  controllerQueryParamsFor,
  toQueryParamKeys,
} from 'client-portal/utils/clinicianSearch/facets/query-param-aliases';
import { service } from '@ember/service';
import { sortCohortByEnrichment } from 'client-portal/utils/clinicianSearch/send-all-catalog';
import Controller from '@ember/controller';
import ENV from 'client-portal/config/environment';

export default class ClinicianSearchController extends Controller {
  @service clinicianSearch;
  @service router;
  @service session;

  queryParams = [
    'pageNumber',
    ...controllerQueryParamsFor(FILTER_PARAM_NAMES),
    'globalMonarchChannelId',
  ];

  @tracked pageNumber = 1;
  @tracked name = null;
  @tracked availableDays = null;
  @tracked availableTimes = null;
  @tracked officeIds = null;
  @tracked cptCodes = null;
  @tracked specialty = null;
  @tracked insurance = null;
  @tracked treatmentType = null;
  @tracked approaches = null;
  @tracked globalMonarchChannelId = null;

  get isSignedIn() {
    return !!this.session.currentClient;
  }

  get isNotSignedIn() {
    return !this.isSignedIn;
  }

  get resolvedRouteParams() {
    return {
      ...this.clinicianSearch.query.toRouteParams(),
      pageNumber: this.pageNumber,
      ...toQueryParamKeys({
        name: this.name,
        availableDays: this.availableDays,
        availableTimes: this.availableTimes,
        officeIds: this.officeIds,
        cptCodes: this.cptCodes,
        specialty: this.specialty,
        insurance: this.insurance,
        treatmentType: this.treatmentType,
        approaches: this.approaches,
      }),
    };
  }

  get enrichmentFilters() {
    return {
      officeIds: [],
      cptCodeRateId: null,
      weekdays: [],
      timeBuckets: [],
    };
  }

  @cached
  get resolvedPage() {
    let enrichmentVersion = this.clinicianSearch.nextSlots.enrichmentVersion;
    void enrichmentVersion;

    let sortFn = records =>
      sortCohortByEnrichment(
        records,
        id => this.clinicianSearch.nextSlots.enrichmentStatusFor(id, this.enrichmentFilters),
        id => this.clinicianSearch.nextSlots.nextAvailableAt(id, this.enrichmentFilters)
      );

    return this.clinicianSearch.sendAll.resolvePage(
      this.resolvedRouteParams,
      this.model.pageSize,
      sortFn
    );
  }

  @cached
  get clinicians() {
    return this.resolvedPage.clinicians;
  }

  @cached
  get meta() {
    return this.clinicianSearch.query.buildConsumerMetaForClinicianSearch(this.resolvedPage.meta, {
      defaultPageSize: this.model.pageSize,
      maxPages: ENV.clinicianSearchMaxPages,
    });
  }

  resetQueryParams() {
    this.pageNumber = 1;
    this.name = null;
    this.availableDays = null;
    this.availableTimes = null;
    this.officeIds = null;
    this.cptCodes = null;
    this.specialty = null;
    this.insurance = null;
    this.treatmentType = null;
    this.approaches = null;
    this.globalMonarchChannelId = null;
  }
}
